<div id="toxicologyOtherMeds" style="padding: 8px"  [style.display]="hasResults ? 'block' : 'none'">
    <div style="text-align: center; background-color: rgba(191, 191, 191, 0.15); height: 24px">
        <h5 style="height: 24px">Other Reported Medications</h5>
    </div>
    <dx-html-editor class="pathology-result-container"  [disabled]="true" [value]="results" style="border: 0" ></dx-html-editor>
</div>
